<template>
  <v-container
    fluid
  >
    <div class="text-h2">
      Perfil
    </div>
    <v-row
      align="start"
      justify="center"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-card
          class="mx-auto"
        >

        <v-card-text>Cambiar información de usuario</v-card-text>
          <!-- <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">
                Cambiar información de usuario
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-card-text>
            <v-form
              ref="form"
            >
              <v-text-field
                v-model="firstname"
                label="Nombres"
                prepend-icon="mdi-account"
                :rules="firstnameRules"
              />
              <v-text-field
                v-model="lastname"
                label="Apellidos"
                prepend-icon="mdi-account"
                :rules="lastnameRules"
              />
              <v-menu
                ref="menuBirthday"
                v-model="menuBirthday"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="birth_date_computed"
                    label="Fecha de nacimiento"
                    prepend-icon="mdi-cake-variant"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="birth_date"
                  locale="es"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                  @change="save"
                />
              </v-menu>
              <v-select
                v-model="country"
                :items="countryOptions"
                label="País"
                :rules="countryRules"
                prepend-icon="mdi-map-marker"
              />

              <v-select
                v-model="region"
                :items="regionOptions"
                item-text="name"
                label="Región/Provincia"
                :disabled="regionOptions.length < 1"
                :rules="regionRules"
                prepend-icon="mdi-map-marker-plus"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="primary"
              block
              @click="updateData"
            >
              Actualizar datos
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-card
          class="mx-auto"
        >
        <v-card-text>Cambiar contraseña</v-card-text>
          <!-- <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">
                Cambiar contraseña
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-card-text>
            <v-form
              ref="formPass"
            >
              <v-text-field
                v-model="password"
                label="Contraseña"
                prepend-icon="mdi-lock"
                type="password"
                :rules="passRules"
              />
              <v-text-field
                v-model="password_confirm"
                label="Confirma Contraseña"
                prepend-icon="mdi-lock"
                type="password"
                :rules="password_confirmRules"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="primary"
              block
              @click="updatePass"
            >
              Actualizar Contraseña
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import regions from './data.js'

  export default {
    data () {
      return {
        uid: '',
        regions,
        regionOptions: [],
        firstname: '',
        lastname: '',
        password: '',
        password_confirm: '',
        birth_date: new Date().toISOString().substr(0, 10),
        country: '',
        region: '',
        menuBirthday: false,
        firstnameRules: [v => !!v || 'Nombre es requerido'],
        lastnameRules: [v => !!v || 'Apellifo es requerido'],
        emailRules: [
          value => !!value || 'Email es requerido.',
          value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email invalido.'
          },
        ],
        passRules: [v => !!v || 'Contraseña es requerido',
                    value => (value || '').length >= 6 || 'Debe tener mínimo 6 caracteres'],
        password_confirmRules: [
          v => !!v || 'Confirmar contraseña es requerido',
          v => v === this.password || 'Contraseña no es igual',
        ],

        countryRules: [v => !!v || 'País es requerido'],
        regionRules: [v => !!v || 'Ciudad es requerido'],
      }
    },
    computed: {
      ...mapState(['user', 'userData']),
      birth_date_computed: {
        get: function () {
          return this.formatDate(this.birth_date)
        },
        set: function (newValue) {
          console.log(newValue)
        },
      },
      countryOptions () {
        return this.regions.map(c => c.countryName)
      },
    },
    watch: {
      menuBirthday (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },

      country (val) {
        this.regionOptions = this.regions.filter(c => c.countryName === val).flatMap(r => r.regions)
      },

      userData (val) {
        if (val) {
          this.firstname = this.userData.firstname
          this.lastname = this.userData.lastname
          this.birth_date = this.userData.birth_date
          this.country = this.userData.location.country
          this.region = this.userData.location.region
          this.uid = this.user.uid
        }
      },
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        if (this.userData.location) {
          this.firstname = this.userData.firstname
          this.lastname = this.userData.lastname
          this.birth_date = this.userData.birth_date
          this.country = this.userData.location.country
          this.region = this.userData.location.region
          this.uid = this.user.uid
        }
      },
      save (date) {
        this.$refs.menuBirthday.save(date)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      updateData () {
        this.$store.commit('SET_LOADING', true)

        var location = {
          country: this.country,
          region: this.region,
        }
        const dataUser = {
          firstname: this.firstname,
          lastname: this.lastname,
          birth_date: this.birth_date,
          uid: this.uid,
          location,
        }
        if (this.$refs.form.validate()) {
          this.$store.dispatch('UPDATE_USER', dataUser)
          this.$store.commit('SET_LOADING', false)
        } else {
          console.log('Faltan datos')
          this.$store.commit('SET_LOADING', false)
        }
      },
      updatePass () {
        this.$store.commit('SET_LOADING', true)
        if (this.$refs.formPass.validate()) {
          this.$store.dispatch('UPDATE_PASS', this.password)
        } else {
          console.log('Faltan datos')
          this.$store.commit('SET_LOADING', false)
        }
      },
    },
  }
</script>
